module.exports = __webpack_public_path__ + "img/main-new_m~03.09.2025.eba33bdb.jpg";